import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "as-schematic-player as-schematic-player__home"
}
const _hoisted_2 = { class: "as-schematic-info" }
const _hoisted_3 = { class: "as-d-inline-flex" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "as-schematic-info__is-champion"
}
const _hoisted_7 = {
  key: 1,
  class: "as-schematic-player as-schematic-player__home"
}
const _hoisted_8 = {
  key: 2,
  class: "as-schematic-player as-schematic-player__away"
}
const _hoisted_9 = { class: "as-schematic-info" }
const _hoisted_10 = { class: "as-d-inline-flex" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 0,
  class: "as-schematic-info__is-champion"
}
const _hoisted_14 = {
  key: 3,
  class: "as-schematic-player as-schematic-player__away"
}

import { ref, computed } from "vue";
import type { ITournamentMatchUp } from "~src/interfaces/tennis";
import { setActiveScoreBracketItem } from "~src/helpers/tennis";
import MatchTennisEnum from "~src/enums/tennis/MatchEnum";
import BracketItemMatchNull from "./BracketItemMatchNull.vue";
import IconTheChampion from "~src/components/icons/IconTheChampion.vue";
import MatchEnum from "~src/enums/volleyball/MatchEnum";

import { usecommonStore } from "~src/stores/CommonStore";

const __default__ = {};

interface IProps {
  matchID: string;
  match: ITournamentMatchUp;
  isNull: boolean;
  roundKey?: string;
  roundIndex?: number;
  isShowTheChampion: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'BracketItemMatch',
  props: {
    matchID: {},
    match: {},
    isNull: { type: Boolean, default: false },
    roundKey: {},
    roundIndex: {},
    isShowTheChampion: { type: Boolean, default: false }
  },
  setup(__props: any) {

const commonStore = usecommonStore();


const sportType = computed(() => commonStore.getSportType);
const getScoresBracket = (mode: string, match: any) => {
  let playing = MatchEnum.LIST_STATUS_PLAYING;
  let score = match?.home_score ?? 0;
  if(mode === 'away'){
    score = match?.away_score ?? 0;
  }
  if(sportType.value === 'tennis'){
    playing = MatchTennisEnum.LIST_STATUS_PLAYING;
  }
  const i_match = match?.i_match ?? {};
  if(i_match && i_match?.id){
    // if(playing.includes(i_match?.status_id)){
      const scores = i_match?.scores ?? [];
      if(scores && scores['ft']){
        score = scores['ft'][0];
        if (mode === "away") {
          score = scores['ft'][1];
        }
      }
      
    // }
  }
  
  return score;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["as-schematic-item__body", {
      'as-active': _ctx.match?.match_ids && _ctx.match?.match_ids.includes(_ctx.matchID),
    }])
  }, [
    (_ctx.match.home_team_id && _ctx.match.home_team)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.match?.home_team?.sub_ids?.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.match?.home_team?.sub_ids, (sub, index) => {
                    return (_openBlock(), _createElementBlock("img", {
                      class: _normalizeClass(["as-schematic-info__img", `as-logo-${index}`]),
                      src: _ctx.getImgUrlBySport('team', sub)
                    }, null, 10, _hoisted_4))
                  }), 256))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: "as-schematic-info__img",
                    src: _ctx.getImgUrlBySport('team', _ctx.match.home_team_id)
                  }, null, 8, _hoisted_5))
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["as-schematic-info__name", { isNull: !_ctx.match.home_team_id }])
            }, _toDisplayString(!_ctx.match.home_team_id ? "-" : _ctx.match?.home_team?.name), 3),
            (_ctx.isShowTheChampion && getScoresBracket('home', _ctx.match) > getScoresBracket('away', _ctx.match))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(IconTheChampion)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["as-schematic-score", {
          'as-active':
            _ctx.match.home_team_id && _ctx.match.away_team_id
              ? _unref(setActiveScoreBracketItem)(getScoresBracket('home', _ctx.match), getScoresBracket('away', _ctx.match))
              : '',
          isNull: !_ctx.match.home_team_id,
        }])
          }, [
            _createElementVNode("span", null, _toDisplayString(!_ctx.match.home_team_id ? "-" : getScoresBracket('home', _ctx.match)), 1)
          ], 2)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(BracketItemMatchNull)
        ])),
    (_ctx.match.away_team_id && _ctx.match.away_team)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_ctx.match?.away_team?.sub_ids?.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.match?.away_team?.sub_ids, (sub, index) => {
                    return (_openBlock(), _createElementBlock("img", {
                      class: _normalizeClass(["as-schematic-info__img", `as-logo-${index}`]),
                      src: _ctx.getImgUrlBySport('team', sub)
                    }, null, 10, _hoisted_11))
                  }), 256))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: "as-schematic-info__img",
                    src: 
              _ctx.getImgUrlBySport('team', _ctx.match.away_team_id)
            
                  }, null, 8, _hoisted_12))
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["as-schematic-info__name", { isNull: !_ctx.match.away_team_id }])
            }, _toDisplayString(!_ctx.match.away_team_id ? "-" : _ctx.match?.away_team?.name), 3),
            (_ctx.isShowTheChampion && getScoresBracket('home', _ctx.match) < getScoresBracket('away', _ctx.match))
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(IconTheChampion)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["as-schematic-score", {
          'as-active':
            _ctx.match.home_team_id && _ctx.match.away_team_id
              ? _unref(setActiveScoreBracketItem)(
                  getScoresBracket('home', _ctx.match),
                  getScoresBracket('away', _ctx.match),
                  'away'
                )
              : '',
          isNull: !_ctx.match.away_team_id,
        }])
          }, [
            _createElementVNode("span", null, _toDisplayString(!_ctx.match.away_team_id ? "-" : getScoresBracket('away', _ctx.match)), 1)
          ], 2)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createVNode(BracketItemMatchNull)
        ]))
  ], 2))
}
}

})